import logo from 'design/assets/img/bcn/neobeacons-logo-color.svg';
import NeoHeader from 'design/design_components/neo/layout/NeoHeader.base';
import NeoNavBar from 'design/design_components/neo/menu/NeoNavBar.base';

export default function RouterContainer(props) {
  return (
    <>
      <NeoHeader>
        <NeoNavBar items={props.menu} logo={logo} extra='navbar-principal blue-nav p-jc-between' />
      </NeoHeader>
      {props.children}
    </>
  );
}